import { Box, Text } from '@factorialco/deprecated-design-system'

import BaseSidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

interface Props {
  open: boolean
  onClose: () => void
}

const Sidepanel = ({ open, onClose }: Props) => {
  return (
    <BaseSidepanel
      open={open}
      title={i18n.t('performance_process.analytics.chart_type.9_box_grid')}
      width="wide"
      onClose={() => onClose()}
      closeLabel={i18n.t('common.close')}
    >
      <Box gap="s32">
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.title')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.description')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.9')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.9')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.8')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.8')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.7')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.7')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.6')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.6')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.5')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.5')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.4')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.4')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.3')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.3')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.2')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.2')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="bold">
            {i18n.t('performance_process.analytics.nine_box_grid.scores.1')}
          </Text.Normal>

          <Text.Normal size="200">
            {i18n.t('performance_process.analytics.nine_box_grid.sidepanel.scores.description.1')}
          </Text.Normal>
        </Box>
      </Box>
    </BaseSidepanel>
  )
}

export default Sidepanel
